import React, { type PropsWithChildren } from 'react';

import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuDietaryPreferencesNotices = (props: PropsWithChildren) => {
  const { children } = props;

  return <BodyText sizeMatch={['14']}>{children}</BodyText>;
};
